import { Input } from "antd";
import React, { ChangeEventHandler } from "react";
import { isEmpty } from "lodash";
import "../css/components.css";

type GenericInputFieldProps = {
  handleOnChange: ChangeEventHandler<HTMLInputElement>;
  text: string;
  name: string;
  error: boolean;
};

function GenericInputField({
  text,
  handleOnChange,
  name,
  error,
}: GenericInputFieldProps) {
  return (
    <div className="generic_inputfield_container">
      <Input
        type="text"
        name={name}
        value={text}
        onChange={handleOnChange}
        // style={{ width: "100%",}}
        status={error ? "error" : ""}
      />
    </div>
  );
}

export default GenericInputField;
